"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnConfig = void 0;
const button_1 = require("@components/button");
const tooltip_1 = require("@components/tooltip");
const _utils_1 = require("@utils");
const react_1 = __importDefault(require("react"));
const getColumnConfig = (editHandler) => [
    { width: "60px", cellRender: () => react_1.default.createElement("input", { type: "checkbox" }) },
    {
        title: "ID",
        width: 1,
        cellRender: ({ tokenId }) => tokenId,
    },
    { title: "Name", width: 1, cellRender: ({ token }) => token.name },
    {
        title: "Author",
        width: "120px",
        cellRender: ({ token }) => react_1.default.createElement(tooltip_1.Tooltip, { content: token.author.wallet }, (0, _utils_1.formatAddress)(token.author.wallet)),
    },
    {
        title: "Owner",
        width: "120px",
        cellRender: ({ token }) => react_1.default.createElement(tooltip_1.Tooltip, { content: token.owner.wallet }, (0, _utils_1.formatAddress)(token.owner.wallet)),
    },
    { title: "Created at", width: "280px", cellRender: ({ token }) => (0, _utils_1.formatHumanDateTime)(new Date(token.createdAt)) },
    { title: "Updated at", width: "280px", cellRender: ({ token }) => (0, _utils_1.formatHumanDateTime)(new Date(token.updatedAt)) },
    {
        width: "80px",
        cellRender: ({ tokenId }) => (react_1.default.createElement(button_1.Button, { onClick: () => editHandler(tokenId), type: "primary" }, "Edit")),
    },
];
exports.getColumnConfig = getColumnConfig;
